export const numberSortMethod = (a, b, desc) => {
      // force any string values to lowercase
      a = typeof a === 'string' ? parseInt(a) : a;
      b = typeof b === 'string' ? parseInt(b) : b;
      // force non numeric to the bottom
      a = isNaN(a) ? 0 : a
      b = isNaN(b) ? 0 : b
      return a - b;
}